import { SeverityLevel } from '@microsoft/applicationinsights-web';
import React, { FC, useEffect, useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import * as api from '../../../api/generated';
import { KendoLoading } from '../../../components';
import { workScheduleRowsDisplayType } from '../../../enums';
import '../../../styles/workSchedule.scss';
import { ai } from '../../../utils';
import { IInfoScreenColorsForm } from '../../administration/organization/generalSettings/design/GeneralSettingsDesignInfoScreen';
import { IDeviceDisplaySchedules } from './models';
import ScheduleSlider from './ScheduleSlider';

interface IProps {
    id: number;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
    design: IInfoScreenColorsForm;
}

const InfoScreenDisplayWorkSchedules: FC<IProps> = (props) => {
    const [organizationSchedule, setOrganizationSchedule] = useState<IDeviceDisplaySchedules | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isVertical, setIsVertical] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await api.display.getWorkscheduleByDeviceId(props.id);
                setOrganizationSchedule(response);
                setIsVertical(response?.workScheduleRowsDisplayType === workScheduleRowsDisplayType.Vertical ?? false);
            } catch (ex) {
                props.setError('Įrenginys nerastas');
                ai.appInsights.trackException({
                    exception: new Error('InfoScreenWorkSchedules Error in fetchData' + ex + ', ' + ex?.error),
                    severityLevel: SeverityLevel.Error
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [props.design]);

    return (
        <>
            {!isLoading && organizationSchedule ? (
                <div className="layoutContainer" style={{ backgroundColor: props.design.textColor?.toString() }}>
                    <div className="organizationContainer" style={{ backgroundColor: props.design.primaryColor?.toString() }}>
                        <div className="scheduleContainer">
                            <ScheduleSlider isVertical={isVertical} design={props.design} schedules={organizationSchedule.schedules} />
                        </div>
                    </div>
                </div>
            ) : (
                <KendoLoading />
            )}
        </>
    );
};

export default InfoScreenDisplayWorkSchedules;
